module.exports = __webpack_public_path__ + "static/media/geotechnical_investigation_see_far3.9bbeb420.jpeg";